

import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash';


const NAME = 'transactionType';

export const isLoading = state => state[NAME].isLoading

export const list = state => state[NAME].list

export const selectedId = state => state[NAME].selected

export const selected = createSelector(
  list,
  selectedId,
  (_, props) => props && props.id,
  (_list, _selectedId, _id) => _list[_id || _selectedId]
)

export const transactionTypeByIds = createSelector(
  list,
  (_, props) => props && props.ids,
  (_list,  _ids) => Object.entries(_list)
  .reduce((current, accumulator) => {
    if(_ids.indexOf(+get(accumulator, '0')) > -1){
      return [
        ...current,
        get(accumulator, '1')
      ]
    }

    return current
  }, [])
)